import React, { Fragment } from "react";
import TopBox from "../common/TopBox";
import { RouteName } from "../../lib/routes";
import { format } from "date-fns";
import { ApiResult } from "../../lib/CmsApi";
import Pagination from "../common/Pagination";
import EmptyList from "../magazin/EmptyList";
import Content from "../common/Content";
import TextTeaserComponent from "../common/TextTeaserComponent";
import Section from "../sections/Section";
import { AriaDate } from "../../lib/formatters";
class PressPagination extends Pagination<
  ApiResult<"listPressReleases">["items"][0]
> {}

export type Props = ApiResult<"listPressReleases"> & { page: number };
export default function PressArchivPage(props: Props) {
  return (
    <Fragment>
      <TopBox
        breadCrumpPath={
          [
            {
              route: "press",
              title: "Presse"
            },
            {
              title: "Pressearchiv",
              route: "pressArchiv"
            }
          ] as { title: string; route: RouteName }[]
        }
        title="Pressearchiv"
      />
      <main>
        <Section noTopPadding>
          <PressPagination
            total={props.total}
            items={props.items}
            page={props.page}
            name="Pressearchiv"
            renderItem={press => {
              return (
                <Content padded smallBottomMargin key={press.slug}>
                  <TextTeaserComponent
                    id={"pa_" + press._id}
                    ghost
                    serif
                    layoutType
                    overline={<AriaDate date={press.date} />}
                    headline={press.title}
                    ctaLabel="Weiterlesen"
                    ctaRef={{
                      route: "pressRelease",
                      params: { slug: press.slug }
                    }}
                    text={press.description}
                  />
                </Content>
              );
            }}
            renderEmpty={() => {
              return <EmptyList />;
            }}
          />
        </Section>
      </main>
    </Fragment>
  );
}
